<ng-container *ngIf="isReady">
  <idp-car-widget
    (expandEmit)="expandEmit.emit($event)"
    (openModalEmit)="openModal($event)"
    (formSubmitted)="formSubmitted()"
    [locationSelected]="locationSelected"
    [carsWidgetForm]="bookingCarsFacadeService.carsWidgetForm"
    [viewSearchOptionExpanded]="viewSearchOptionExpanded"
    [resetErrors]="resetErrors"
    [content]="
      (bookingCarsFacadeService.carsWidgetContent$ | ngrxPush) ||
      emptyCarsContent
    "
    (analyticsEvent)="handleAnalytics($event)"
  ></idp-car-widget>
  <idp-airport-dropdown
    *ngIf="isSelected"
    [openModal]="openModalEvent"
    [selectedValue]="locationSelected"
    [airportModalContent]="locationModalContent"
    [searchErrorMessage]="
      bookingCarsFacadeService.airportSearchErrorService.searchErrorMessage
    "
    (airportSelected)="onLocationSelected($event)"
    (searchValueEmit)="searchValue($event)"
    (closeModal)="openModal(false)"
  ></idp-airport-dropdown>
</ng-container>

<div
  *ngIf="!isReady && !showAlert"
  id="mach-core-booking-cars-loader"
  class="page-loader"
></div>

<section
  *ngIf="showAlert"
  id="mach-core-booking-cars-alert"
  class="banner-global-header-alert !p-[0] tablet:!p-24"
>
  <div class="banner-main">
    <div class="banner-content">
      <svg class="banner-icon"></svg>
      <label
        [innerHTML]="bookingCarsFacadeService.adapter.errorBannerMessage"
      ></label>
    </div>
  </div>
</section>
